<template>
  <div class="page-container">
        <div class="my-info">
            <van-row type="flex">
                <van-col span="20" v-if="myUid"><img :src="myLogo" class="my-logo" alt=""> {{myUid?myNick:'请登录'}}</van-col>
                <van-col span="4" class="ta-center" v-if="myUid"><a class="cl-white" href="javascript:;" x-click="go.logout">退出</a></van-col>
                <van-col span="4" class="ta-center" v-else><a class="cl-white" href="javascript:;"  x-click="go.login">登录</a></van-col>
            </van-row>
        </div>
        
        <div class="m-box">
            <img src="../../assets/img/images/index-banner.png" width="100%" alt="">
        </div>
        <div class="m-box card-video">
            <div class="m-card">
                <div class="m-card--bd">
                    <div class="m-video">
                        <video :poster="awardMap.video.img" image="" oncontextmenu="return false" controls="controls" webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow" controlslist="nodownload noremoteplayback" class="k-video" width="100%" :src="awardMap.video.url"></video>
                    </div>
                    <div class="m-video-list">
                        <div v-for="item in awardMap.interview" class="m-video-list__item">
                            <a :href="item.url" target="_blank">
                            <img src="https://imgcdn-prd.pydp888.com/2/2/265729/1880/ab7875398a341b925feb681d7645e197.png?x-oss-process=image/resize,m_fill,w_120,h_120,limit_0/auto-orient,1/quality,q_90" class="u-logo" alt="">
                            <div class="u-text"><span class="cl-red">{{item.title}}</span></div>
                            </a>
                        </div>
                    </div>
                    <div class="ta-center" style="padding:0.2rem;">
                        <a v-if="awardMap.jianghai" :href="awardMap.jianghai.url" target="_blank" class="cl-white b-line">{{awardMap.jianghai.title}}</a>
                    </div>
                </div>
            </div>
            <div style="height: 0.2rem; background:#f22733;"></div>
        </div>
        <div class="m-box card-zpq">
            <div class="m-card">
                <div class="m-card--hd"><a href="/award2019/bless/20190520/" class="link-more b-line">查看全部</a><strong>祝福墙</strong> </div>
                <div class="m-card--bd">
                    <div class="ta-center cl-white text-con">您有什么祝福送给TA的吗？</div>
                    <div class="m-zpq--bg"></div>
                    <div class="m-zpq">                        
                        <div class="m-zpq--bd">                            
                            <iframe :src="awardMap.bless.url" frameborder="0" width="100%" height="100%"></iframe>
                            <a :href="'/award2019/bless/20190520/post/?redirectUrl='+redirectUrl" class="u-btn" target="_blank">发送祝福</a>
                        </div>
                    </div>
                    <div class="m-zpq--ft"></div>
                </div>
            </div>
        </div>
        <div class="m-box card-wzzl">
            <div class="m-card">
                <div class="m-card--hd"><strong>{{myUid?myNick:'请您登录'}}</strong></div>
                <div class="m-card--bd ta-center">
                    <div class="m-warp">
                        <div class="cl-white ta-center text-con">{{awardMap.textTip.text3}}</div>
                        <a href="javascript:;" class="u-btn" v-if="myUid" @click="wfRoad(awardMap.growth.url)">生成我的王粉之路报告</a>
                        <a href="javascript:;" class="u-btn" x-click="go.login" v-else>登录</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-box card-huodong">
            <div class="m-card">
                <div class="m-card--hd"><strong>王粉节狂欢活动玩不停~</strong></div>
                <div class="m-card--bd">
                    <!-- <div class="m-warp">  
                        <div class="m-box--white "></div>
                    </div> -->
                    <div class="m-img__box">
                        <img src="../../assets/img/images/index-huodong1.png" alt="">
                        <a href="javascript:;" @click="goLink(awardMap.lotteryMap.url)" class="u-btn btn-01" title="立即抽奖">立即抽奖</a>
                    </div>                    
                    <div class="m-img__box">
                        <img src="../../assets/img/images/index-huodong2.png" alt="">
                        <a href="javascript:;" @click="goLink('/kline/11/cup/index')" class="u-btn btn-02" title="进入斗k">进入斗K</a>
                        <div class="hd-dk">
                            <home-cups></home-cups>
                            <!--
                            <a href="#" class="hd-dk__link"  target="_blank" title="获奖名单1">获奖名单1</a>
                            <a href="#" class="hd-dk__link"  target="_blank" title="获奖名单2">获奖名单2</a>
                            <a href="#" class="hd-dk__link"  target="_blank" title="获奖名单3">获奖名单3</a>
                            -->
                        </div>
                    </div>
                    <div class="m-img__box">
                        <img src="../../assets/img/images/index-huodong3.png" alt="">
                        <a href="javascript:;" @click="goLink(awardMap.dkSale.url)" class="u-btn btn-03" title="立即购买">立即购买</a>
                    </div>
                    <div class="m-img__box">
                        <img src="../../assets/img/images/index-huodong4.png" alt="">
                        <div class="hd-goods">
                            <a v-for="item in awardMap.goodsList" :href="item.url" target="_blank" class="u-btn btn-04" :title="item.btnText">{{item.btnText}}</a>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        <div class="m-box card-qr">
            <div class="m-card">
                <div class="m-card--hd"><strong>关注公众号，领取惊喜大奖</strong></div>
                <div class="m-card--bd">
                    <div class="m-warp">
                        <div class="m-warp--line">
                            <h3 class="cl-white ta-center">时间：5月20日 10:00-5月22日 17:00</h3>
                            <div class="m-qr-box">
                                <div class="col-2 m-box--white">
                                    <p class="cl-red ta-center">跑赢大盘的王者</p>
                                    <div class="cl-red ta-center"><img src="https://staticcdn-yy-prd.pydp888.com/g/img/qr/2wm_pydp.jpg"  alt="微信公众号"></div>
                                    <small>扫码关注，回复“速成班1”，即可免费领取《金牌股民速成班》试看视频1</small>
                                </div>
                                <div class="col-2 m-box--white">
                                    <p class="cl-red ta-center">王者财经午评</p>
                                    <div class="ta-center"><img src="https://staticcdn-yy-prd.pydp888.com/g/img/qr/2wm_wuping.jpg"  alt="午评公众号"></div>
                                    <small>扫码关注，回复“速成班2”，即可免费领取《金牌股民速成班》试看视频2</small>
                                </div>
                                <div class="col-2 m-box--white">
                                    <p class="cl-red ta-center">王粉尊享服务号</p>
                                    <div class="ta-center"><img src="https://staticcdn-yy-prd.pydp888.com/g/img/qr/2wm_zunguifuwu.jpg"  alt="尊享服务号"></div>
                                    <small>扫码关注，回复“速成班3”，即可免费领取《金牌股民速成班》试看视频3</small>
                                </div>
                                <div class="col-2 m-box--white">
                                    <p class="cl-red ta-center">玄商</p>
                                    <div class="ta-center"><img src="https://staticcdn-yy-prd.pydp888.com/g/img/qr_xs/qr_xs_gzh.jpg"  alt="玄商公众号"></div>
                                    <small>扫码关注，回复“斗K”，即可免费领取7天斗K权限和3张学习卡</small>
                                </div>
                            </div>
                            <div class="cl-white">                            
                                <div><strong>关注方法：</strong></div>                           
                                <div>1.手机微信：长按二维码识别关注；</div>
                                <div>2.手机APP：分享至微信，在微信中长按二维码识别关注；</div>
                                <div>3.电脑：直接使用微信“扫一扫”识别关注；</div>
                            </div>   
                        </div>                     
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapState} from 'vuex'
    import HomeCups from './home-cups'
    export default {
        data() {
            return {
                redirectUrl : location.href,
            }
        },
        components: {
            'home-cups': HomeCups
        },
        computed: {
            ...mapGetters( ['myUid', 'myNick', 'myLogo']),
            ...mapState('config', ['awardMap',]),
            ...mapGetters('config', ['matchList', 'cupOf', 'beginTime', 'endTime']),
            ...mapGetters('timer', ['isBefore', 'isAfter', 'leftFor'])
        },
        methods: {
            ...mapActions(['goLogin','goLogout']),
            wfRoad(url){
                if(this.isBefore(this.beginTime)){
                    this.$dialog.alert({
                        message: this.awardMap.textTip.text2
                    })
                } else {
                    location.href = url
                }
                
            },
            goLink(url){
                if(!url) return
                if(this.isBefore(this.beginTime)){
                    this.$dialog.alert({
                        message: this.awardMap.textTip.text1
                    })
                } else {
                    location.href = url
                }
            }
        },
        created() {
        },
    
    }
</script>
